import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-com-modal-print',
  templateUrl: './com-modal-print.component.html',
  styleUrls: ['./com-modal-print.component.scss']
})

export class ComModalPrintComponent {

  myForm: FormGroup;
  data1: any;

  CommissionPayment = new FormGroup({
    bank_no: new FormControl(),
    bank_Acname: new FormControl(),
    bank_date: new FormControl(),
    end: new FormControl(),
    bank_bname: new FormControl(),
    bank_IFSC: new FormControl(),
    bank_Branch: new FormControl(),
    bank_Cheque: new FormControl(),
    commission_percentage: new FormControl(),
    tds_percentage: new FormControl(),
    commission_no: new FormControl(),
  });
  setPaymentdata: any;
  myModalList: any[];

  constructor(private dialogRef: MatDialogRef<ComModalPrintComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private cdr: ChangeDetectorRef, private fb: FormBuilder) { }


  rcpt_no: string = '';
  commissionData: any[] = [];
  totalCommission: number = 0;
  getmodaldata: any
  gettotal: any;
  commission: any;
  tds: any;
  NetPay: any;
  tdspercentage: any
  balamount: any
  commissionAmount: any
  commissionPercentage: any
  totalSelectedAmount: any
  seamt: any;
  tdsamount: any
  com_paid_date: any
  cheque_no: any
  voucher_no: any
  branch: any
  ifsc_code: any
  bank_name: any
  account_no: any
  acc_name: any


ngOnInit(): void {

  this.getmodaldata = [];
  
  this.tdsamount = this.data.innerData?.tdsAmt;
  this.tdspercentage = this.data.innerData?.tdspercentage;
  this.balamount = this.data.innerData?.balamount;
  this.commissionAmount = this.data.innerData?.seamt;
  this.commissionPercentage = this.data.innerData?.commissionPercentage;
  this.rcpt_no = this.data.innerData?.commision_no;

  if (this.rcpt_no) {
    this.service.getdatabycomreceipt(this.rcpt_no)
      .subscribe((res: any[]) => {

        console.log('API Response:', res); // ✅ correct

        this.getmodaldata = res; // MUST be array

        // ✅ Total commission
        this.totalCommission = this.getmodaldata
          .reduce((sum, d) => sum + (Number(d.com_amt) || 0), 0);
      });
  }
}


  // Method to calculate total net amount
  getTotalNetAmount(): number {
    if (!this.getmodaldata || this.getmodaldata.length === 0) {
      return 0;
    }
    return this.getmodaldata
      .map(d => Number(d.amount) || 0)
      .reduce((a, b) => a + b, 0);
  }

  // Method to calculate total received amount
  getTotalReceivedAmount(): number {
    if (!this.getmodaldata || this.getmodaldata.length === 0) {
      return 0;
    }
    return this.getmodaldata
      .map(d => Number(d.rcv_amt) || 0)
      .reduce((a, b) => a + b, 0);
  }

  // Method to calculate net payable commission (commission amount - tds amount)
  getNetPayableCommission(): number {
    const totalCommissionAmt = this.totalCommission || 0;
    const tdsAmount = Number(this.getmodaldata?.[0]?.tds_amount) || 0;
    return totalCommissionAmt - tdsAmount;
  }

  // printCommission() {
  //   throw new Error('Method not implemented.');
  // }

  closeexp(): void {
    this.dialogRef.close();
  }

  exportExcel(fileName): void {
    console.log('Export function called with fileName:', fileName);

    let element = document.getElementById('print-section1');
    console.log('Element found:', element);

    if (!element) {
      console.error('Element with ID "print-section1" not found in DOM');
      return;
    }

    try {
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
      console.log('Worksheet created:', ws);

      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      XLSX.writeFile(wb, fileName + '.xlsx');
      console.log('File should be downloaded');
    } catch (error) {
      console.error('Error during export:', error);
    }
  }

}